import { render } from "./OrganizationsList.vue?vue&type=template&id=f9640ac0&ts=true"
import script from "./OrganizationsList.vue?vue&type=script&lang=ts"
export * from "./OrganizationsList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ulucefe\\source\\repos\\birimza.admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__